import { useGetChatsQuery, useCreateChatMutation } from '../features/chat/chatApiSlice';

export const useChats = (shopid, process = 'User', options = {}) => {
  const queryArg = { shopid, process };
  const result = useGetChatsQuery(queryArg, options);
  const [createChat, createResult] = useCreateChatMutation();
  return { ...result, createChat, createResult };
};

export default useChats;
